import { Outlet, createFileRoute, redirect } from '@tanstack/react-router';

import { Layout } from '@/components/layout';

export const Route = createFileRoute('/_authenticated/$tenantId')({
  beforeLoad: ({ context, params }) => {
    const { tenantId } = params;

    if (!context.auth.hasRole(['viewer', 'editor', 'admin'], tenantId)) {
      throw redirect({
        to: '/',
      });
    }
  },
  component: () => (
    <Layout>
      <Outlet />
    </Layout>
  ),
});
